
import { Vue, Component, Prop, Watch,Model } from "vue-property-decorator";
import { BaseVue } from "@newview/base-web";
@Component({
  name: "",
  components: {
    
  },
})
export default class imgBase64Class extends BaseVue {
  @Model('on-change') defaultValue!: any
  // @Prop({ default: () => "" }) imgCode!: String; //图片base64编码
  @Prop({ default: () => "选择图片" }) btntxt!: String; //选择图片按钮上文本
  @Prop({ default: () => "未上传图片" }) noPicturetxt!: String; //图片为空时显示文本
  @Prop({ default: () => false }) readonly!: Boolean; //是否只读
  @Prop({ default: () => 0 }) width!: Number;    //图片展示区域宽
  @Prop({ default: () => 200 }) height!: Number; //图片展示区域高
	
	@Watch("defaultValue")
  defaultValueChange(){
    // console.log(this.defaultValue)   
  }
  fileOneId = this.NewGuid()
  mounted() {}	
	loadStyle(){
		return {width:this.width==0?'100%':this.width+"px",height:this.height+"px"}
	}
  handleChangeToop() {
    var file = this.Id(this.fileOneId);
    if (file != null && file.value != "") {
      this.preImg(this.fileOneId);
    }
  }
  async preImg(fileId) {
    this.getImgToBase64(this.getFileUrl(fileId), (data) => {   
			this.$emit("on-change", data);   
      $("#"+this.fileOneId).val(""); //清空，单一文件可重复选择
    });
		// let res:any = await this.compress(this.Id(fileId).files[0],95)
		// this.$emit("on-change", res.compressBase64);
  }
}
